<template>
    
    <span v-if="hasUrl()">
        <a :href="currentUrl" target="_blank">
            <span v-if="getIcon() == 'fa-instagram'"><img src="/images/rebrush22/icons/icon-instagram-black.svg"></span>
            <span v-else-if="getIcon() == 'fa-facebook-square'"><img src="/images/rebrush22/icons/icon-facebook-black.svg"></span>
            <span v-else><i :class="['fa', getIcon(),'fa-2x']"></i></span>
        </a>
    </span>
</template>

<script>
	export default {
		name: 'profilePlatform',
		props: {
            platform: String,
            propertyKey: String,
            url: String
        },
         data: function() {
        	return {
                currentUrl: null
        	}
        },
        created: function() {
            var self = this;
            this.currentUrl = this.url;
            this.$bus.$on('changedUrl', ($event) => {
                if ($event.propertyKey === this.propertyKey) {
                    this.currentUrl = $event.url;
                }
            });
        },
        methods: {
            hasUrl: function() {
                if (this.currentUrl != null && this.currentUrl.length > 0) {
                    return true;
                }
                return false;
            },
            getIcon: function() {
                switch (this.platform) {
                    case 'AMAZON':
                        return 'fa-amazon-square';
                    case 'FACEBOOK':
                        return 'fa-facebook-square';
                    case 'GOOGLEPLUS':
                        return 'fa-googleplus-square';
                    case 'INSTAGRAM':
                        return 'fa-instagram';
                    case 'PINTEREST':
                        return 'fa-pinterest-square';
                    case 'TWITTER':
                        return 'fa-twitter-square';
                    case 'YOUTUBE':
                        return 'fa-youtube-square';
                    }
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfilePlatform.vue?5d2a83d6